<section>
  <div class="card-header card-form-header mt-1">
    <!-- Fomulário do Titular -->
    <div class="card collapse-icon accordion-icon-rotate" style="margin-bottom: 1rem">
      <!-- Dados Cadastrais -->
      <div
        id="headingCollapse51"
        class="card-header collapse-format"
        [ngClass]="errorMessageDadosTitular == false ? 'border-info' : 'border-danger'">
        <a
          data-toggle="collapse"
          href="#collapseLeads"
          aria-expanded="false"
          aria-controls="collapseLeads"
          class="card-title lead info"
          [ngClass]="errorMessageDadosTitular == false ? 'info' : 'danger'">
          <i class="fa fa-user" aria-hidden="true"></i>
          Dados do Titular
          <i
            style="color: red"
            *ngIf="errorMessageDadosTitular"
            placement="top"
            ngbTooltip="Verifique os campos obrigatórios."
            class="cursor-pointer fa fa-exclamation-triangle"
            aria-hidden="true"></i>
        </a>
      </div>
      <div
        id="collapseLeads"
        role="tabpanel"
        aria-labelledby="headingCollapseLeads"
        class="card-collapse collapse"
        aria-expanded="false">
        <div class="card-content">
          <div class="card-body">
            <form [formGroup]="formBeneficiario">
              <div class="col-12">
                <div class="form-group row">
                  <!-- Nome -->
                  <div class="form-group mb-1 col-md-8 col-sm-12">
                    <label for="name">Nome Completo</label>
                    <input
                      (ngModelChange)="onFieldChange()"
                      type="text"
                      class="form-control round"
                      id="name"
                      maxlength="250"
                      formControlName="name"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['name'].errors && isFormSubmited
                      }" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo=""
                      [maxLength]="250"
                      [minLength]="10"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Tipo de Proposta -->
                  <div class="form-group col-sm-12 col-md-4">
                    <label for="proposalType">Tipo de Proposta</label>
                    <ng-select
                      id="proposalType"
                      class="round shadow somente-leitura"
                      [multiple]="false"
                      [loading]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      formControlName="proposalType"
                      notFoundText="Nenhum registro localizado">
                      <ng-option *ngFor="let option of listaEnumTipoProposta" [value]="option.value">
                        {{ option.description }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!-- CPF -->
                  <div class="form-group mb-1 col-sm-12 col-md-4">
                    <label for="cpf">CPF</label>
                    <input
                      name="cpf"
                      (ngModelChange)="onFieldChange()"
                      [showMaskTyped]="true"
                      mask="000.000.000-00"
                      formControlName="cpf"
                      class="form-control border-radius"
                      [ngClass]="{
                        'is-invalid':
                          formBeneficiario.controls['cpf'].invalid &&
                          formBeneficiario.controls['cpf'].errors &&
                          isFormSubmited
                      }"
                      id="cpf" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="cpf"
                      [maxLength]="250"
                      [minLength]="10"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Data de Nascimento -->
                  <div class="col-12 col-sm-12 col-md-4 mb-2">
                    <label for="birthDate">Data de Nascimento</label>
                    <div class="input-group">
                      <input
                        #datepicker="bsDatepicker"
                        bsDatepicker
                        name="birthDate"
                        maxlength="10"
                        type="text"
                        class="form-control round somente-leitura"
                        id="birthDate"
                        formControlName="birthDate"
                        readonly />
                    </div>
                  </div>
                  <!-- Estado Civil -->
                  <div class="form-group col-md-4 col-sm-12">
                    <label for="civilStatusId">Estado Civil</label>
                    <ng-select
                      (ngModelChange)="onFieldChange()"
                      [multiple]="false"
                      [loading]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      class="round shadow"
                      formControlName="civilStatusId"
                      [ngClass]="{
                        'campo-obrigatorio': formBeneficiario.controls['civilStatusId'].errors && isFormSubmited
                      }"
                      notFoundText="Nenhum registro localizado">
                      <ng-option *ngFor="let estadoCivil of listaEstatusCivil" [value]="estadoCivil.id">
                        {{ estadoCivil.name }}
                      </ng-option>
                    </ng-select>
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="civilStatusId"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Sexo -->
                  <div class="form-group mb-1 col-sm-12 col-md-4">
                    <label for="sex">Sexo</label>
                    <br />
                    <label style="margin-right: 50px; cursor: not-allowed !important">
                      <input
                        [ngClass]="{
                          'is-invalid': formBeneficiario.controls['sex'].errors && isFormSubmited
                        }"
                        (ngModelChange)="onFieldChange()"
                        formControlName="sex"
                        [value]="1"
                        id="active"
                        type="radio"
                        class="input-radio off"
                        name="sex"
                        checked
                        style="cursor: not-allowed !important" />
                      Masculino
                    </label>
                    <label style="cursor: not-allowed !important">
                      <input
                        [ngClass]="{
                          'is-invalid': formBeneficiario.controls['sex'].errors && isFormSubmited
                        }"
                        (ngModelChange)="onFieldChange()"
                        formControlName="sex"
                        [value]="2"
                        id="Inactive"
                        type="radio"
                        class="input-radio on"
                        name="sex"
                        style="cursor: not-allowed !important" />
                      Feminino
                    </label>
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="sex"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Gênero -->
                  <div class="form-group mb-1 col-sm-12 col-md-4">
                    <label for="gender">Gênero</label>
                    <ng-select
                      (change)="onChangeGender($event)"
                      [multiple]="false"
                      [loading]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      notFoundText="Nenhum registro localizado"
                      class="round shadow"
                      [ngClass]="{
                        'campo-obrigatorio': formBeneficiario.controls['gender'].errors && isFormSubmited
                      }"
                      formControlName="gender">
                      <ng-option *ngFor="let genero of _listaGeneros" [value]="genero.value">
                        {{ genero.description }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!-- Outro Gênero  -->
                  <div *ngIf="isOtherGender" class="form-group col-sm-12 col-md-4">
                    <label for="otherGender">Outro Gênero</label>
                    <input
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['otherGender'].errors && isFormSubmited
                      }"
                      (change)="onChangeGender($event)"
                      class="round form-control"
                      id="otherGender"
                      formControlName="otherGender" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="otherGender"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- CNS -->
                  <div class="form-group mb-1 col-sm-12 col-md-4">
                    <ng-template #faqTemplateCNS>
                      <app-faqs [fieldName]="'CNS'"></app-faqs>
                    </ng-template>
                    <label for="cns">
                      CNS
                      <a
                        href="https://cnesadm.datasus.gov.br/cnesadm/publico/usuarios/cadastro"
                        target="_blank"
                        class="input-icon">
                        <i
                          placement="top"
                          aria-hidden="true"
                          class="fa fa fa-exclamation-circle"
                          tooltipClass="tooltip"></i>
                      </a>
                    </label>
                    <input
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['cns'].errors && isFormSubmited
                      }"
                      mask="000 0000 0000 0000"
                      (ngModelChange)="onFieldChange()"
                      [showMaskTyped]="true"
                      type="text"
                      class="form-control round"
                      id="cns"
                      formControlName="cns" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="cns"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Nome da Mãe -->
                  <div class="form-group mb-1 col-sm-12" [ngClass]="isOtherGender ? 'col-md-8' : 'col-md-6'">
                    <label for="mothersName">Nome da Mãe</label>
                    <input
                      (ngModelChange)="onFieldChange()"
                      type="text"
                      class="form-control round"
                      id="mothersName"
                      maxlength="250"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['mothersName'].errors && isFormSubmited
                      }"
                      formControlName="mothersName" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="mothersName"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    <div
                      class="errorsName"
                      *ngIf="
                        formBeneficiario.get('mothersName')?.invalid &&
                        (formBeneficiario.get('mothersName')?.touched || formBeneficiario.get('mothersName')?.dirty)
                      ">
                      <div class="errorsName" *ngIf="formBeneficiario.get('mothersName')?.hasError('checkName')">
                        {{ formBeneficiario.get('mothersName')?.errors?.['checkName'] }}
                      </div>
                    </div>
                  </div>
                  <!-- Profissão -->
                  <div class="form-group mb-1 col-sm-12 col-md-6">
                    <label for="professionId">Profissão</label>
                    <ng-select
                      (change)="onChangeProfession($event)"
                      (ngModelChange)="onFieldChange()"
                      [multiple]="false"
                      [loading]="false"
                      [closeOnSelect]="true"
                      [searchable]="true"
                      notFoundText="Nenhum registro localizado"
                      formControlName="professionId"
                      class="round shadow somente-leitura">
                      <ng-option *ngFor="let profisao of listaProfissao" [value]="profisao.id">
                        {{ profisao.name }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!-- Outras Profissões  -->
                  <div *ngIf="isOtherProfession" class="form-group col-sm-12 col-md-6">
                    <label for="otherProfession">Outra Profissão</label>
                    <input
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['otherProfession'].errors && isFormSubmited
                      }"
                      (change)="onChangeProfession($event)"
                      class="round form-control somente-leitura"
                      id="otherProfession"
                      formControlName="otherProfession" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="otherProfession"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Informações de Contato -->
                  <h4 class="form-section col-sm-12 col-md-12 mt-2">
                    <i class="fa fa-address-book"></i>
                    Informações de Contato
                  </h4>
                  <!-- Email -->
                  <div class="form-group mb-1 col-sm-12 col-md-8">
                    <label for="email">E-mail</label>
                    <input
                      type="text"
                      class="form-control round"
                      id="email"
                      formControlName="email"
                      [maxlength]="249"
                      (ngModelChange)="onFieldChange()"
                      [required]="condionalDeObrigatoriedadeContatos()"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['email'].errors && isFormSubmited
                      }" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="email"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    <div
                      class="errors"
                      *ngIf="
                        formBeneficiario.get('email')?.invalid &&
                        (formBeneficiario.get('email')?.touched || formBeneficiario.get('email')?.dirty)
                      ">
                      <div class="errors" *ngIf="formBeneficiario.get('email')?.hasError('checkEmail')">
                        {{ formBeneficiario.get('email')?.errors?.['checkEmail'] }}
                      </div>
                    </div>
                  </div>
                  <!-- Telefone Comercial-->
                  <div class="form-group col-md-4 col-sm-12">
                    <label for="businessPhone">Telefone Comercial</label>
                    <input
                      mask="(00) 0000-0000"
                      [showMaskTyped]="true"
                      class="round form-control"
                      formControlName="businessPhone"
                      (ngModelChange)="onFieldChange()"
                      [required]="condionalDeObrigatoriedadeContatos()"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['businessPhone'].errors && isFormSubmited
                      }"
                      type="text" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="businessPhone"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Telefone Residencial-->
                  <div class="form-group col-md-4 col-sm-12">
                    <label for="homePhone">Telefone Residencial</label>
                    <input
                      mask="(00) 0000-0000"
                      [showMaskTyped]="true"
                      class="round form-control"
                      formControlName="homePhone"
                      (ngModelChange)="onFieldChange()"
                      [required]="condionalDeObrigatoriedadeContatos()"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['homePhone'].errors && isFormSubmited
                      }"
                      type="text" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="homePhone"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <!-- Celular -->
                  <div class="form-group col-md-4 col-sm-12 mb-2">
                    <label for="mobilePhone">Celular</label>
                    <input
                      mask="(00) 00000-0000"
                      [showMaskTyped]="true"
                      class="round box-shadow-4 form-control"
                      formControlName="mobilePhone"
                      type="text"
                      (ngModelChange)="onFieldChange()"
                      [required]="condionalDeObrigatoriedadeContatos()"
                      [ngClass]="{
                        'is-invalid': formBeneficiario.controls['mobilePhone'].errors && isFormSubmited
                      }" />
                    <app-validacao-form-input
                      [nomeFormulario]="formBeneficiario"
                      nomeCampo="mobilePhone"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                  <ng-container *ngIf="!heOdonto">
                    <!-- Dados da Operadora e Atendimento - Titular -->
                    <h4 class="form-section col-sm-12 col-md-12 mt-2">
                      <i class="fa fa-address-book"></i>
                      Dados da Operadora e Atendimento - Titular
                    </h4>
                    <!-- Operadora Anterior -->
                    <div class="form-group mb-1 col-sm-12 col-md-8">
                      <label for="PreviousOperator">Operadora Anterior</label>
                      <input
                        maxlength="250"
                        [ngClass]="{
                          'is-invalid': formBeneficiario.controls['previousOperator'].errors && isFormSubmited
                        }"
                        (ngModelChange)="onFieldChange()"
                        type="text"
                        class="form-control round"
                        id="previousOperator"
                        formControlName="previousOperator" />
                      <app-validacao-form-input
                        [nomeFormulario]="formBeneficiario"
                        nomeCampo="previousOperator"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>
                    <!-- Tempo de Permanência -->
                    <div class="form-group mb-1 col-sm-12 col-md-4">
                      <label for="dwellTime">Tempo de Permanência</label>
                      <input
                        (ngModelChange)="onFieldChange()"
                        type="number"
                        class="form-control round"
                        id="dwellTime"
                        formControlName="dwellTime"
                        [ngClass]="{
                          'is-invalid': formBeneficiario.controls['dwellTime'].errors && isFormSubmited
                        }"
                        min="0"
                        oninput="
                          this.value = Math.min(parseInt(this.value))
                            .toString()
                            .replace(/[^0-9]/g, '')
                        " />
                      <app-validacao-form-input
                        [nomeFormulario]="formBeneficiario"
                        nomeCampo="dwellTime"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>
                    <!-- Estado -->
                    <div class="form-group col-sm-12 col-md-4">
                      <label for="stateId">Estado</label>
                      <ng-select
                        [multiple]="false"
                        [loading]="false"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        notFoundText="Nenhum registro localizado"
                        [ngClass]="{
                          'campo-obrigatorio': formBeneficiario.controls['stateId'].errors && isFormSubmited
                        }"
                        (change)="onChangeState($event)"
                        class="round shadow"
                        formControlName="stateId">
                        <ng-option *ngFor="let estado of listaEstados" [value]="estado.id">
                          {{ estado.name }}
                        </ng-option>
                      </ng-select>
                      <app-validacao-form-input
                        [nomeFormulario]="formBeneficiario"
                        nomeCampo="stateId"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>
                    <!-- Cidade -->
                    <div class="form-group col-sm-12 col-md-4">
                      <label for="cityId ">Cidade</label>
                      <ng-select
                        [multiple]="false"
                        [loading]="false"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        notFoundText="Nenhum registro localizado"
                        [ngClass]="{
                          'campo-obrigatorio': formBeneficiario.controls['cityId'].errors && isFormSubmited
                        }"
                        class="round shadow"
                        formControlName="cityId">
                        <ng-option *ngFor="let cidade of listaCidades" [value]="cidade.id">
                          {{ cidade.name }}
                        </ng-option>
                      </ng-select>
                      <app-validacao-form-input
                        [nomeFormulario]="formBeneficiario"
                        nomeCampo="cityId"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>

                    <!-- <ng-container *ngIf="ehReducaoCarencia">
                      <div class="input-group mb-1 col-sm-12 col-md-6">
                        <label for="cat">Carta de Tempo de Permanência</label>
                        <br />
                        <div
                          class="input-group mb-2"
                          *ngIf="!temDocumentoCTPExistente() || mostrarInputUploadCTP || novoArquivoCTPSelecionado"
                          class="input-group">
                          <input
                            placeholder="Selecione um arquivo para upload"
                            type="file"
                            class="form-control round"
                            id="fileCTP"
                            accept=".pdf,.jpg,.jpeg,.png"
                            (change)="onFileCTPSelected($event)" />
                          <div *ngIf="mostrarInputUploadCTP" class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-inputs btn-secondary round"
                              (click)="cancelarUploadCTP()">
                              <i class="fa fa-times"></i>
                              Cancelar
                            </button>
                          </div>
                        </div>
                        <div *ngIf="temDocumentoCTPExistente() && !novoArquivoCTPSelecionado" class="input-group mt-1">
                          <input
                            type="text"
                            class="form-control round"
                            [value]="getNomeArquivoCTP()"
                            readonly
                            placeholder="Arquivo atual" />
                          <div class="input-group-append mb-1">
                            <button
                              style="max-height: 40px"
                              type="button"
                              class="btn btn-success btn-inputs"
                              (click)="baixarDocumentoCTP()">
                              <i class="fa fa-download"></i>
                              Baixar
                            </button>
                            <button
                              *ngIf="!somenteLeituraStep"
                              style="max-height: 40px"
                              type="button"
                              class="btn btn-warning round btn-inputs"
                              (click)="mostrarInputUploadCTP = true">
                              <i class="fa fa-upload"></i>
                              Substituir
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-group mb-1 col-sm-12 col-md-6">
                        <label for="carta2">Documento de Adimplância do Plano de Origem</label>
                        <br />

                         <div
                          *ngIf="!temDocumentoDAPOExistente() || mostrarInputUploadDAPO || novoArquivoDAPOSelecionado"
                          class="input-group">
                          <input
                            placeholder="Selecione um arquivo para upload"
                            type="file"
                            class="form-control round"
                            id="fileDAPO"
                            accept=".pdf,.jpg,.jpeg,.png"
                            (change)="onFileDAPOSelected($event)" />
                          <div *ngIf="mostrarInputUploadDAPO" class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-secondary btn-inputs round"
                              (click)="cancelarUploadDAPO()">
                              <i class="fa fa-times"></i>
                              Cancelar
                            </button>
                          </div>
                        </div>

                         <div
                          *ngIf="temDocumentoDAPOExistente() && !novoArquivoDAPOSelecionado"
                          class="input-group mt-1">
                          <input
                            type="text"
                            class="form-control round mb-1"
                            [value]="getNomeArquivoDAPO()"
                            readonly
                            placeholder="Arquivo atual" />
                          <div class="input-group-append mb-1">
                            <button
                              style="max-height: 40px"
                              type="button"
                              class="btn btn-success btn-inputs"
                              (click)="baixarDocumentoDAPO()">
                              <i class="fa fa-download"></i>
                              Baixar
                            </button>
                            <button
                              *ngIf="!somenteLeituraStep"
                              style="max-height: 40px"
                              type="button"
                              class="run btn btn-warning btn-inputs round"
                              (click)="mostrarInputUploadDAPO = true">
                              <i class="fa fa-upload"></i>
                              Substituir
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->

                    <div class="form-group mb-1 mt-2 col-sm-12 col-md-12">
                      <label style="cursor: not-allowed !important">
                        <input
                          (change)="inserirValidadoresAntigaOperadora(true)"
                          (ngModelChange)="onFieldChange()"
                          formControlName="analysisPeriodReductionCheck"
                          [value]="true"
                          id="active"
                          type="radio"
                          class="input-radio on"
                          name="analysisPeriodReductionCheck"
                          style="cursor: not-allowed !important" />
                        &nbsp;&nbsp; Desejo submeter-me a Análise Técnica de Redução de Carências e declaro ter
                        conhecimento de que a análise atenderá a critérios técnicos internos da administradora, que tem
                        a faculdade de conceder ou não a redução de carências. (Neste caso, deverá ser preenchido o
                        formulário posterior).
                      </label>
                      <label style="cursor: not-allowed !important">
                        <input
                          checked
                          (change)="inserirValidadoresAntigaOperadora(false)"
                          (ngModelChange)="onFieldChange()"
                          formControlName="analysisPeriodReductionCheck"
                          [value]="false"
                          id="Inactive"
                          type="radio"
                          class="input-radio off"
                          name="analysisPeriodReductionCheck"
                          style="cursor: not-allowed !important" />
                        &nbsp;&nbsp; Dispenso a Análise Técnica de Redução de Carências e declaro estar ciente de que ao
                        aderir ao plano de saúde, as coberturas contratuais estarão condicionadas ao cumprimento dos
                        períodos de carência informados no Quadro 1 acima.
                      </label>
                      <app-validacao-form-input
                        [nomeFormulario]="formBeneficiario"
                        nomeCampo="analysisPeriodReductionCheck"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>
                  </ng-container>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Formulário do Dependente -->
    <app-proposta-entidade-dependente
      [somenteLeituraColaboradorBeneficiario]="ehColaborador"
      [entidadeId]="entidadeId"></app-proposta-entidade-dependente>
    <!-- Formulário de Endereço -->
    <app-endereco
      [estaAberto]="false"
      [mostrarTipoEndereco]="true"
      [ocultarBtnAcao]="true"
      [ocultarTabela]="true"></app-endereco>
    <!-- Formulário de Dados Bancários -->
    <div
      *ngIf="!this.ehInclusaoDependente"
      class="card collapse-icon accordion-icon-rotate"
      style="margin-bottom: 1rem">
      <div
        id="colapseBancohead"
        class="card-header collapse-format"
        [ngClass]="mostrarMensagemErroBanco == false ? 'border-info' : 'border-danger'">
        <a
          data-toggle="collapse"
          href="#bancoRef"
          aria-expanded="false"
          aria-controls="bancoRef"
          class="card-title lead info"
          [ngClass]="mostrarMensagemErroBanco == false ? 'info' : 'danger'">
          <i class="fa fa-university"></i>
          Dados Bancários
          <i
            style="color: red"
            *ngIf="mostrarMensagemErroBanco"
            placement="top"
            ngbTooltip="Verifique os campos obrigatórios."
            class="cursor-pointer fa fa-exclamation-triangle"
            aria-hidden="true"></i>
        </a>
      </div>
      <div
        id="bancoRef"
        role="tabpanel"
        aria-labelledby="colapseBancohead"
        class="card-collapse collapse"
        aria-expanded="false">
        <h3 class="text-center form-section mt-3">
          <b>Autorização de Débito em Conta Corrente</b>
        </h3>
        <div class="card-content">
          <div class="card-body">
            <!-- Formulário -->
            <form class="form row" [formGroup]="formGrupDadosBancarios">
              <!-- Banco -->
              <div class="form-group mb-1 col-sm-12" [ngClass]="bancoConveniado ? 'col-md-12' : 'col-md-6'">
                <label for="bankId">Banco</label>
                <ng-select
                  (change)="changeOutroBanco($event, template)"
                  id="bankId"
                  (ngModelChange)="onFieldChange()"
                  class="round shadow"
                  [multiple]="false"
                  [loading]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  formControlName="bankId"
                  required
                  [bindValue]="'id'"
                  notFoundText="Nenhum registro localizado"
                  [ngClass]="{
                    'campo-obrigatorio': formGrupDadosBancarios.controls['bankId'].errors && isFormSubmited
                  }">
                  <ng-option *ngFor="let option of listaDeBancosConveniados" [value]="option">
                    {{ option.name }}
                  </ng-option>
                </ng-select>
                <app-validacao-form-input
                  [nomeFormulario]="formGrupDadosBancarios"
                  nomeCampo="bankId"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Outros Bancos -->
              <div
                *ngIf="!bancoConveniado"
                class="form-group mb-1 col-sm-12 col-md-6"
                style="margin-bottom: 40px !important">
                <label for="baotherBankIdnkId">Outros Bancos</label>
                <ng-select
                  id="otherBankId"
                  (ngModelChange)="onFieldChange()"
                  class="round shadow"
                  [multiple]="false"
                  [loading]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  formControlName="otherBankId"
                  required
                  notFoundText="Nenhum registro localizado"
                  [ngClass]="{
                    'campo-obrigatorio': formGrupDadosBancarios.controls['otherBankId'].errors && isFormSubmited
                  }">
                  <ng-option *ngFor="let option of listaDeBancosNaoConveniados" [value]="option.id">
                    {{ option.name }}
                  </ng-option>
                </ng-select>
                <app-validacao-form-input
                  [nomeFormulario]="formGrupDadosBancarios"
                  nomeCampo="otherBankId"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Agência -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <label for="agency">Agência</label>
                <br />
                <input
                  type="text"
                  (ngModelChange)="onFieldChange()"
                  id="agency"
                  maxlength="5"
                  class="form-control round"
                  id="agency"
                  formControlName="agency"
                  [ngClass]="{
                    'is-invalid': formGrupDadosBancarios.controls['agency'].errors && isFormSubmited
                  }" />
                <app-validacao-form-input
                  [nomeFormulario]="formGrupDadosBancarios"
                  nomeCampo="agency"
                  [maxLength]="10"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Digito -->
              <div class="form-group mb-1 col-sm-12 col-md-2">
                <label for="agencyDigit">Digito</label>
                <br />
                <input
                  type="text"
                  (ngModelChange)="onFieldChange()"
                  id="agencyDigit"
                  maxlength="5"
                  class="form-control round"
                  formControlName="agencyDigit" />
              </div>
              <!-- Conta -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <label for="account">Conta</label>
                <br />
                <input
                  type="text"
                  (ngModelChange)="onFieldChange()"
                  class="form-control round"
                  id="account"
                  maxlength="10"
                  formControlName="account"
                  [ngClass]="{
                    'is-invalid': formGrupDadosBancarios.controls['account'].errors && isFormSubmited
                  }" />
                <app-validacao-form-input
                  [nomeFormulario]="formGrupDadosBancarios"
                  nomeCampo="account"
                  [maxLength]="10"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Digito -->
              <div class="form-group mb-1 col-sm-12 col-md-2">
                <label for="accountDigit">Digito</label>
                <br />
                <input
                  type="text"
                  (ngModelChange)="onFieldChange()"
                  class="form-control round"
                  id="accountDigit"
                  maxlength="5"
                  formControlName="accountDigit"
                  oninput="
                    this.value = Math.min(parseInt(this.value))
                      .toString()
                      .replace(/[^0-9]/g, '')
                  "
                  [ngClass]="{
                    'is-invalid': formGrupDadosBancarios.controls['accountDigit'].errors && isFormSubmited
                  }" />
                <app-validacao-form-input
                  [nomeFormulario]="formGrupDadosBancarios"
                  nomeCampo="accountDigit"
                  [maxLength]="12"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Botões -->

    <div class="form-actions mb-1 float-right" style="text-align: right; margin-top: 10px">
      <app-declinio-proposta
        [stepAtual]="stepAtual"
        (propostaDeclinada)="receberDeclinio($event)"></app-declinio-proposta>

      <button
        *ngIf="permissao.podeCadastrarEditar && stepAtual == propostaStepEnum.RETORNO_OPERADORA"
        data-dismiss="modal"
        type="button"
        class="btn cursor-pointer btn-round btn-danger white btn-min-width box-shadow-4 mr-1 mb-1"
        (click)="abrirModalSumulaRecusa()"
        style="font-weight: 500 !important">
        <i class="fa fa-thumbs-down"></i>
        Recusa de Sumula 21
      </button>

      <button
        (click)="onSalvarDadosBeneficiario()"
        type="button"
        class="btn cursor-pointer btn-round btn-success white btn-min-width box-shadow-4 mr-1 mb-1">
        <i class="fa fa-save white"></i>
        Atualizar
      </button>

      <button
        *ngIf="podeExibirBotaoEnviarPortabilidade"
        data-dismiss="modal"
        type="button"
        class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-min-width mr-1 mb-1"
        (click)="abrirModalPortabilidadeAutomaticamente()"
        style="font-weight: 500 !important">
        <i class="fa fa-exchange"></i>
        Portabilidade
      </button>
      <!-- Não pode mostrar o botão enviar para operadora para o corretor externo -->
      <button
        *ngIf="podeExibirBotaoEnviarOperadora"
        (click)="abrirModaVigenciaPrevista(this.modalVigenciaPrevistaTemplate)"
        type="button"
        class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4 mr-1 mb-1">
        <i class="fa fa-send white"></i>
        Enviar Operadora
      </button>
    </div>
  </div>
</section>
<!-- Modal outros Bancos -->
<ng-template #template>
  <div class="modal-header bg bg-warning">
    <h5 class="modal-title white title-modal" id="exampleModalLongTitle">Outro Banco</h5>
    <button (click)="fecharModalOutroBanco()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center container">
    <div class="modal-body">
      <h2 class="mb-1">Favor entrar em contato com o corretor.</h2>
      <p class="mt-1">
        O pagamento do seu plano é contratualmente via débito automático e foi selecionado um banco no qual não temos
        convênio, pedimos que entre em contato com seu corretor.
      </p>
    </div>
  </div>

  <div class="modal-footer">
    <button data-dismiss="modal" (click)="fecharModalOutroBanco()" type="button" class="round btn btn-info">
      <i class="fa fa-check"></i>
      Ciente e continuar
    </button>
  </div>
</ng-template>

<!-- Modal aceite/recusa Portabilidade -->
<ng-template #modalPortabilidade class="modal-content">
  <div class="modal-header bg bg-info">
    <h5 class="modal-title white title-modal">
      <i class="fa fa-exchange mr-2"></i>
      Portabilidade - Beneficiário(s)
    </h5>
    <button (click)="fecharModalPortabilidade()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body modal-portabilidade-body">
    <form *ngIf="formPortabilidade" [formGroup]="formPortabilidade">
      <div formArrayName="beneficiariosPortabilidade" class="beneficiarios-container">
        <div *ngIf="getListaBeneficiariosAguardandoPortabilidadeOrdenada().length > 0; else semBeneficiarios">
          <!-- Titular (sempre visível) -->
          <ng-container
            *ngFor="let beneficiario of getListaBeneficiariosAguardandoPortabilidadeOrdenada(); let i = index">
            <div
              *ngIf="beneficiario?.holderProposalId"
              [formGroupName]="i"
              class="beneficiario-card p-2 border rounded mb-2">
              <div class="beneficiario-header d-flex justify-content-between align-items-center mb-1">
                <h5 class="mb-0">
                  {{ beneficiario?.name || 'Beneficiário' }}
                  <span>(Titular)</span>
                </h5>
              </div>

              <div class="opcoes-portabilidade">
                <div class="form-group mb-1 col-sm-12 col-md-5">
                  <label for="opcaoPortabilidade">Portabilidade</label>
                  <br />
                  <label style="margin-right: 50px; cursor: pointer">
                    <input
                      type="radio"
                      formControlName="opcaoPortabilidade"
                      [value]="'aceitar'"
                      class="input-radio off"
                      (change)="onOpcaoPortabilidadeChange(i, 'aceitar')" />
                    Aceitar
                  </label>
                  <label style="cursor: pointer">
                    <input
                      formControlName="opcaoPortabilidade"
                      [value]="'recusar'"
                      type="radio"
                      class="input-radio on"
                      (change)="onOpcaoPortabilidadeChange(i, 'recusar')" />
                    Recusar
                  </label>
                  <app-validacao-form-input
                    [nomeFormulario]="getBeneficiarioGroup(i)"
                    nomeCampo="opcaoPortabilidade"
                    [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                </div>
              </div>

              <div *ngIf="getOpcaoPortabilidade(i) === 'aceitar'" class="secao-aceite p-2 bg-light rounded">
                <h4 class="text-success mb-1">Dados para Aceite da Portabilidade</h4>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <label class="form-label">Número da Carteirinha</label>
                    <input
                      [showMaskTyped]="true"
                      mask="0 000 000000000000 0"
                      type="text"
                      class="form-control round"
                      formControlName="carteirinha"
                      [ngClass]="{
                        'is-invalid': getCarteirinhaControl(i).invalid && isFormSubmited
                      }" />
                    <app-validacao-form-input
                      [nomeFormulario]="getBeneficiarioGroup(i)"
                      nomeCampo="carteirinha"
                      [maxLength]="250"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>

                  <div class="col-md-6 col-sm-12 mb-1">
                    <label for="vigencia">Vigência da Carteirinha</label>
                    <div class="input-group">
                      <input
                        #vigenciaPicker="bsDatepicker"
                        bsDatepicker
                        name="vigencia"
                        [attr.data-index]="i"
                        maxlength="10"
                        type="text"
                        class="form-control round bg-white"
                        id="vigencia-{{ i }}"
                        [minDate]="minDate"
                        [bsConfig]="bsConfigVigencia"
                        [triggers]="''"
                        formControlName="vigencia"
                        (ngModelChange)="formatarCampoData($event, i)" />
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-outline-secondary botao-calendario"
                          (click)="abrirCalendarioVigencia(vigenciaPicker)">
                          <i class="fa fa-calendar"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="getOpcaoPortabilidade(i) === 'recusar'" class="secao-recusa p-2 bg-light rounded">
                <h4 class="text-danger mb-1">Motivos para Recusa da Portabilidade</h4>
                <div formArrayName="motivosRecusa" class="motivos-recusa">
                  <div *ngIf="getMotivosRecusaArray(i).invalid && isFormSubmited" class="text-danger small mb-2">
                    Selecione pelo menos um motivo para a recusa da portabilidade.
                  </div>
                  <div *ngFor="let motivo of opcoesRecusa; let j = index" class="mb-2">
                    <label class="checkbox-container d-block mb-0">
                      <input type="checkbox" [formControlName]="j" class="form-check-input" />
                      <span class="checkmark"></span>
                      <span class="option-text">{{ motivo?.texto || '' }}</span>
                      <span *ngIf="motivo?.observacao" class="observacao-text d-block mt-1 small text-muted">
                        {{ motivo.observacao }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Área dos Dependentes -->
          <div class="dependentes-area mt-3">
            <h5 class="mb-1">Dependentes</h5>

            <!-- Mensagem quando titular recusa -->
            <div *ngIf="titularRecusouPortabilidade" class="text-center p-4 border rounded bg-light">
              <i class="fa fa-info-circle text-warning fa-2x mb-2"></i>
              <h5 class="text-warning"><b>Dependentes Recusados Automaticamente</b></h5>
              <p class="text-muted mb-0">
                Ao recusar a portabilidade do titular, todos os dependentes são automaticamente recusados.
              </p>
            </div>

            <!-- Lista de dependentes quando titular aceita -->
            <div *ngIf="!titularRecusouPortabilidade">
              <ng-container
                *ngFor="let beneficiario of getListaBeneficiariosAguardandoPortabilidadeOrdenada(); let i = index">
                <div
                  *ngIf="!beneficiario?.holderProposalId"
                  [formGroupName]="i"
                  class="beneficiario-card p-2 border rounded mb-2">
                  <div class="beneficiario-header d-flex justify-content-between align-items-center mb-1">
                    <h5 class="mb-0">
                      {{ beneficiario?.name || 'Dependente' }}
                    </h5>
                  </div>

                  <div class="opcoes-portabilidade">
                    <div class="form-group mb-1 col-sm-12 col-md-5">
                      <label for="opcaoPortabilidade">Portabilidade</label>
                      <br />
                      <label style="margin-right: 50px; cursor: pointer">
                        <input
                          type="radio"
                          formControlName="opcaoPortabilidade"
                          [value]="'aceitar'"
                          class="input-radio off"
                          (change)="onOpcaoPortabilidadeChange(i, 'aceitar')" />
                        Aceitar
                      </label>
                      <label style="cursor: pointer">
                        <input
                          formControlName="opcaoPortabilidade"
                          [value]="'recusar'"
                          type="radio"
                          class="input-radio on"
                          (change)="onOpcaoPortabilidadeChange(i, 'recusar')" />
                        Recusar
                      </label>
                      <app-validacao-form-input
                        [nomeFormulario]="getBeneficiarioGroup(i)"
                        nomeCampo="opcaoPortabilidade"
                        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                    </div>
                  </div>

                  <div *ngIf="getOpcaoPortabilidade(i) === 'aceitar'" class="secao-aceite p-2 bg-light rounded">
                    <h4 class="text-success mb-1">Dados para Aceite da Portabilidade</h4>
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="form-label">Número da Carteirinha</label>
                        <input
                          [showMaskTyped]="true"
                          mask="0 000 000000000000 0"
                          type="text"
                          class="form-control round"
                          formControlName="carteirinha"
                          [ngClass]="{
                            'is-invalid': getCarteirinhaControl(i).invalid && isFormSubmited
                          }" />
                        <app-validacao-form-input
                          [nomeFormulario]="getBeneficiarioGroup(i)"
                          nomeCampo="carteirinha"
                          [maxLength]="250"
                          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="getOpcaoPortabilidade(i) === 'recusar'" class="secao-recusa p-2 bg-light rounded">
                    <h4 class="text-danger mb-1">Motivos para Recusa da Portabilidade</h4>
                    <div formArrayName="motivosRecusa" class="motivos-recusa">
                      <div *ngIf="getMotivosRecusaArray(i).invalid && isFormSubmited" class="text-danger small mb-2">
                        Selecione pelo menos um motivo para a recusa da portabilidade.
                      </div>
                      <div *ngFor="let motivo of opcoesRecusa; let j = index" class="mb-2">
                        <label class="checkbox-container d-block mb-0">
                          <input type="checkbox" [formControlName]="j" class="form-check-input" />
                          <span class="checkmark"></span>
                          <span class="option-text">{{ motivo?.texto || '' }}</span>
                          <span *ngIf="motivo?.observacao" class="observacao-text d-block mt-1 small text-muted">
                            {{ motivo.observacao }}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-template #semBeneficiarios>
          <div class="text-center p-4">
            <p class="text-muted">Nenhum beneficiário aguardando portabilidade</p>
          </div>
        </ng-template>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-min-width mr-1 mb-1"
      (click)="fecharModalPortabilidade()"
      style="font-weight: 500 !important">
      <i class="ft-x"></i>
      Cancelar
    </button>
    <button
      (click)="enviarBeneficiariosPortabilidade()"
      type="button"
      class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4 mr-1 mb-1">
      <i class="fa fa-send"></i>
      Cadastrar e Enviar
    </button>
  </div>
</ng-template>
<!-- Modal aceite/recusa Sumula 21 -->
<ng-template #modalSumulaRecusaTemplate class="modal-content">
  <div class="modal-header bg bg-info">
    <h5 class="modal-title white title-modal">
      <i class="fa fa-exchange mr-2"></i>
      Sumula 21
    </h5>
    <button (click)="fecharModalSumula21()()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body modal-portabilidade-body">
    <div class="table-responsive">
      <div class="table-responsive">
        <table class="table table-responsive table-bordered">
          <thead class="bg-table-geia white">
            <tr>
              <th class="text-center">Nome</th>
              <th class="text-center">Tipo</th>
              <th class="text-center col-1">
                <input
                  type="checkbox"
                  [(ngModel)]="checkboxSelecionarTodos"
                  (change)="selecionarTodos($event)"
                  [ngModelOptions]="{standalone: true}"
                  class="form-check-input"
                  id="selecionarTodos" />
                <label
                  class="form-check-label d-flex align-items-center"
                  for="selecionarTodos"
                  style="white-space: nowrap">
                  Todos
                </label>
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let grupo of listabeneficiariosComSumula21 | keyvalue">
              <tr>
                <td>
                  {{ grupo.value.titular.name }}
                </td>
                <td class="text-center">
                  <span class="badge badge-success round">Titular</span>
                </td>
                <td class="text-center p-0">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'titular_' + grupo.value.titular.id"
                      [checked]="isSelecionado(grupo.value.titular.id)"
                      (change)="toggleSelecionado(grupo.value.titular.id, $event)" />
                    <label class="form-check-label" [for]="'titular_' + grupo.value.titular.id"></label>
                  </div>
                </td>
              </tr>

              <tr *ngFor="let dependente of grupo.value.dependentes">
                <td style="padding-left: 30px">
                  {{ dependente.name }}
                </td>
                <td class="text-center">
                  <span class="badge badge-info round">Dependente</span>
                </td>
                <td class="text-center p-0">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'dependente_' + dependente.id"
                      [checked]="isSelecionado(dependente.id)"
                      (change)="toggleSelecionado(dependente.id, $event)" />
                    <label class="form-check-label" [for]="'dependente_' + dependente.id"></label>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <app-table-footer [lista]="listabeneficiariosComSumula21"></app-table-footer>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-min-width mr-1 mb-1"
      (click)="fecharModalSumula21()"
      style="font-weight: 500 !important">
      <i class="ft-x"></i>
      Cancelar
    </button>
    <button
      (click)="abrirModalConfirmacao()"
      type="button"
      class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4 mr-1 mb-1">
      <i class="fa fa-send"></i>
      Enviar ({{ beneficiarioComSumulasSelecionados.length }})
    </button>
  </div>
</ng-template>
<!-- Botão -->

<!-- Modal -->
<ng-template #modalConfirmacao let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirmar Envio</h4>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 text-center mb-1">
        <h2 class="mb-2 bold-preto-400">Os seguintes beneficiários serão enviados:</h2>
        <ul>
          <li *ngFor="let item of getBeneficiariosSelecionados(); let i = index">
            <strong>{{ i + 1 }} - {{ item.nome }}</strong>
            - {{ item.tipo }}
          </li>
        </ul>

        <div class="col-md-12 mt-1 mb-2 text-center bold-preto-400">
          <h3>Deseja continuar?</h3>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-success round box-shadow-4 mr-2" (click)="confirmarEnvio(modal)">
        <i class="ft-thumbs-up"></i>
        Confirmar
      </button>
      <button type="button" class="btn btn-warning round box-shadow-4" (click)="fecharModalSumula21Confirmar()">
        <i class="ft-thumbs-down"></i>
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal Vigência Manual -->
<ng-template #modalVigenciaPrevista>
  <div class="modal-header bg bg-info">
    <h5 class="modal-title white title-modal" id="exampleModalLongTitle">Vigência</h5>
    <button (click)="fecharModalVigenciaPrevista()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center container">
    <div class="modal-body">
      <h4>{{ textoModalVigenciaManual }}</h4>
      <form [formGroup]="formProposta">
        <app-campo-data
          class="col-sm-12 col-md-4"
          [nomeCampo]="'Vigência Prevista'"
          [control]="formProposta.get('manualEffectiveDate')"
          [maxDate]="maxDate"></app-campo-data>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button data-dismiss="modal" (click)="adicionarVigencia()" type="button" class="round btn btn-info">
      <i class="fa fa-check"></i>
      Adicionar
    </button>
  </div>
</ng-template>
